<template lang="pug">
b-modal#qrcodeModal.modal.pt-0(
  centered,
  hide-footer="",
  title="",
  tabindex="-1",
  aria-labelledby="qrcodeModal",
  aria-hidden="true",
  ref="qrcodeModal"
)
  .content.text-center
    h5.text-center 課程報名QRCode
    qrcode-vue.text-center.w-100.my-3(:value="url", :size="qrcodeSize")
    .enroll_url
      small.mr-1 報名網址
      input#url(type="text", :value="url", readonly)
      small#copy.copyBtn.text-sm.ml-1.border.rounded.p-1(@click="copyEvent") 複製
</template>

<script>
import QrcodeVue from "qrcode.vue";
import crypto from "@/utils/crypto";

export default {
  name: "DialogQrcode",
  components: {
    QrcodeVue,
  },
  props: {
    orderID: Number,
    email: String,
  },
  data() {
    return {
      url: "",
    };
  },
  methods: {
    copyEvent() {
      var input = document.getElementById("url");
      input.select(); // 選中文本 document.execCommand("copy");
      document.execCommand("Copy");
    },
  },
  computed: {
    qrcodeSize() {
      if (this.$store.state.screenWidth < 576) {
        return this.$store.state.screenWidth * 0.7;
      } else {
        if (this.$store.state.screenWidth * 0.5 > 300) {
          return 300;
        } else {
          return this.$store.state.screenWidth * 0.5;
        }
      }
    },
  },
  watch: {
    orderID: {
      handler() {
        let temp = {
          orderID: this.orderID,
          email: this.email,
        };

        //TODO
        this.url =
          "http://" +
          location.host +
          "/anotherInfo?token=" +
          encodeURIComponent(
            crypto.encryptAES(JSON.stringify(temp), crypto.aesKey)
          );
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #qrcodeModal .modal-header {
  border: 0;
  padding-bottom: 0 !important;
  padding-top: 0.5rem !important;
}

::v-deep #qrcodeModal .modal-body {
  padding-top: 0;
}

::v-deep #qrcodeModal .close:not(:disabled):not(.disabled):hover {
  opacity: 0.75;
}

.copyBtn {
  cursor: pointer;
  display: inline-block;

  &:hover {
    background: $c-text;
    color: $color_blue;
  }
}

input {
  font-size: 80%;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
